import gql from 'graphql-tag';
import { mutation } from 'services/graphql';

export const surfaceNodeMovedOnSurfaceMutation = gql`
  mutation surfaceNodeMovedOnSurface($input: SurfaceNodeMovedOnSurfaceInput!) {
    surfaceNodeMovedOnSurface(input: $input)
  }
`;

export default mutation(surfaceNodeMovedOnSurfaceMutation);
